import { CodetableId } from './constants';
import { manageOptionsButton } from './manage-options-button';

export { manageOptionsButton };

export const manageOptionsUnit = (label: string) =>
  manageOptionsButton(label, CodetableId.unit);
export const manageOptionsLocation = (label: string) =>
  manageOptionsButton(label, CodetableId.location);
export const manageOptionsUserGroup = (label: string) =>
  manageOptionsButton(label, CodetableId.userGroup);
